import { Component, input } from '@angular/core';
import { GridContainerComponent } from '../containers/grid-container.component';

@Component({
  imports: [GridContainerComponent],
  selector: 'ui-page-header',
  template: `
    <div class="relative h-full w-full rounded-lg">
      <div
        class="absolute top-0 left-0 right-0 h-[104px]"
        [class]="class()"
      ></div>
      <div class="relative w-full">
        <ui-grid-container>
          <ng-content></ng-content>
        </ui-grid-container>
      </div>
    </div>
  `,
})
export class PageHeaderComponent {
  class = input<string>('bg-neutral-light');
}
